import { createContext } from 'react'

type TabsContextType = {
  selectedTab: string
}

export const TabsContext = createContext<TabsContextType | undefined>(undefined)
